
function getAuthUserId() {
    return localStorage.getItem('authUserId');
}


function getStoredDataUsingKey(storageKey, property, defaultValue) {
    const loggedInUserId = getAuthUserId();
    const key = `user_${loggedInUserId}_${storageKey}`;

    const stored = localStorage.getItem(key);
    if (stored && stored !== '') {
        try {
            const parsed = JSON.parse(stored);
            return parsed?.[property] ?? defaultValue;
        } catch (e) {
            console.error('Error parsing localStorage:', e);
        }
    }
    return defaultValue;
};

function setAllStoredData(storageKey, data, convertToJson = false) {
    const loggedInUserId = getAuthUserId();
    const key = `user_${loggedInUserId}_${storageKey}`;

    if (convertToJson) {
        data = JSON.stringify(data);
    }
    localStorage.setItem(key, JSON.stringify(data));
}

function getAllStoredData(storageKey, convertToJson = true) {
    const loggedInUserId = getAuthUserId();
    const key = `user_${loggedInUserId}_${storageKey}`;

    const stored = localStorage.getItem(key);
    if (stored && stored !== '') {
        try {
            const parsed = JSON.parse(stored);
            return convertToJson ? JSON.stringify(parsed) : parsed;
        } catch (e) {
            console.error('Error parsing localStorage:', e);
        }
    }
    return null;
}

function removeStoredData(storageKey) {
    const loggedInUserId = getAuthUserId();
    const key = `user_${loggedInUserId}_${storageKey}`;
    localStorage.removeItem(key);
}


function setSingleStoredData(storageKey, data) {
    const loggedInUserId = getAuthUserId();
    const key = `user_${loggedInUserId}_${storageKey}`;
    localStorage.setItem(key, data);
}

function getSignleStoredData(storageKey) {
    const loggedInUserId = getAuthUserId();
    const key = `user_${loggedInUserId}_${storageKey}`;
    return localStorage.getItem(key);
}

function setStoredDataUsingKey(storageKey, key, value) {
    try {
        const stored = JSON.parse(localStorage.getItem(storageKey)) || {};
        stored[key] = value;
        localStorage.setItem(storageKey, JSON.stringify(stored));
    } catch (error) {
        console.error("Error storing data:", error);
    }
};

function removeStoredProperty(storageKey, property) {
    const loggedInUserId = getAuthUserId();
    const key = `user_${loggedInUserId}_${storageKey}`;

    const stored = localStorage.getItem(key);

    if (!stored) return;

    try {
        const parsed = JSON.parse(stored);

        if (parsed && Object.prototype.hasOwnProperty.call(parsed, property)) {
            delete parsed[property];
            localStorage.setItem(key, JSON.stringify(parsed));
        }
    } catch (e) {
        console.error('Error removing stored property:', e);
    }
}

export {
    getStoredDataUsingKey,
    setAllStoredData,
    getAllStoredData,
    removeStoredData,
    setSingleStoredData,
    getSignleStoredData,
    setStoredDataUsingKey,
    removeStoredProperty
};
